import type React from 'react';
import './StatusDot.scss';

export interface StatusDotProps {
  /** live = green, idle = grey, blue = brand, warning = amber, danger = red */
  tone?: 'live' | 'idle' | 'blue' | 'warning' | 'danger';
  pulse?: boolean;
  size?: number;
}

export const StatusDot: React.FC<StatusDotProps> = ({ tone = 'live', pulse = false, size = 7 }) => (
  <span
    className={`status-dot status-dot--${tone}${pulse ? ' status-dot--pulse' : ''}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  />
);

export default StatusDot;
